const data = {
  text: 'Jetzt Wertermittlung sichern',
  subline: 'In nur 60 Sekunden',
  link: '100% kostenlos & unverbindlich',
  scrollTo: 'configurator'
}

export default data
